import React from "react";
import { WebEventoDocumentoEntidade } from "../../../../entidades";

interface IProps {
  docs: WebEventoDocumentoEntidade[];
  indexAtivo: number;
}

export const Indicators: React.FC<IProps> = ({
  docs,
  indexAtivo
}) => {
  return (
    <>
      <ol className={"carousel-indicators"} style={{ "background": "rgba(0,0,0,0.3)" }}>
        {docs && docs.map((_, index) => {
          return (
            <li key={index} className={indexAtivo === index ? "active" : ""}></li>
          )
        })}
      </ol>
    </>
  );
}